
import './ViewUtil.css'
import { List, Tabs, Input, Ellipsis, Grid, Avatar, SpinLoading, Popup } from 'antd-mobile';
import { 
    DownFill,
} from 'antd-mobile-icons';
import React from 'react';
import { BigDecimalZero, ConvertToRate, DecimalZero, FullURL } from './FactoryUtil';
import { TradeMoreIcon, TrendIcon, FavoritesIcon, FavoritesOKIcon } from '../icons';
import { DoFavorite } from '../market/FavoritesManager';

export function PropEqual(prevProps, nextProps) {
    if (prevProps.prop === nextProps.prop) {
      return true; // 如果prop相同，跳过渲染
    }
    return false;
}


export const RootView = React.memo(({children}) => {
    return (
        <div className='rootView'>
            {children}
        </div>
    )
});

export const BodyView = React.memo((props) => {
    return (
        <div className='bodyView' {...props}>
            <div className='content' {...props.content}>{props.children}</div>
        </div>
    )
});

export const TabBarView = React.memo(({children}) => {
    return (
        <div className='flexView'>
            {children}
        </div>
    )
});

export const ListView = React.memo((props) => {
    return (
        <List style={{
            '--padding-left' : '0', 
            '--padding-right' : '0', 
            '--border-inner' : 'none',
            paddingTop : props.paddingTop || '0',
            paddingBottom : props.paddingBottom || '0'}} {...props}>
            {props.children}
        </List>
    )
});

export const TabsView = React.memo((props) => {
    return (
        <Tabs style={{
            '--content-padding' : '0',
            '--active-line-color' : 'transparent',
            '--title-font-size' : (props.fontSize || '16px')}} stretch = {false} {...props}>
            {props.children}
        </Tabs>
    )
});

export const ButtonView = React.memo((props) => {
    return (
        <button className='buttonView' type='button' {...props}>
            <span>{props.children}</span>
        </button>
    );
});

export const InputView = React.memo((props) => {
    
    const color = props.color || '#000'
    let css = {}
    if(props.isBottomBorder === false) {
        css = {borderBottom : 'none', borderBottomLeftRadius : '0', borderBottomRightRadius : '0'}
    }
    css['borderColor'] = color
    return (
        <div className='inputViewWrapper' style={css}><div className='title' style={{color : color}}>{props.title}</div>
            <div style={{display : 'flex'}}>
                <div style={{flex : 1}}><Input {...props}/></div>
                <div>{props.right}</div>
            </div>
        </div>
    );
});

export const HeaderTitleView = React.memo((props) => {
    return (
        <div className='headerTitleView' {...props}>{props.children}</div>
    );
});

export const OptionView = React.memo((props) => {
    const data = props.data;
    return (
        <Grid columns={data.length} style={{'--gap-horizontal' : '8px' , '--gap-vertical' : '15px'}} {...props}>
            {
                data.map((item, index) => (
                <Grid.Item onClick={item.onClick} key={index}>
                     <div style={{textAlign : 'center'}}>
                        <div>{item.icon}</div>
                        <div style={{fontSize : '12px'}}>{item.title}</div>
                    </div>
                </Grid.Item>
                ))
            }
        </Grid>
    );
});

export const EllipsisView = React.memo((props) => {
    return(
        <Ellipsis direction='end' {...props}/>
    );
});

export const NavBarTitleView = React.memo((props) => {
    return(
        <div className='navBarTitleView' onClick={()=>props.onClick()}>
            <div style={{display : 'flex', alignItems : 'center', minHeight : '26px'}}>
                {
                    props.src === undefined ? '' : <Avatar src={props.src} style={{'--size' : '28px', '--border-radius' : '100px'}}/>
                }
                <div style={{margin : '0 8px'}}>{props.children}</div>
                {
                    props.icon === undefined ? '' : <div style={{marginRight : '8px', display : 'flex'}}>{props.icon}</div>
                }
            </div>
        </div>
    );
});


export const DividerLoginView = React.memo((props) => {
    const size = '44px'
    return(
        <div className='dividerView' style={{width : '100%'}}>
            <div onClick={()=> {props.onClickLeft()}} className='dividerItemView dividerLeftView' style={{height : size}}><span>Login</span></div>
            <div onClick={()=> {props.onClickRight()}} className='dividerItemView dividerRightView' style={{height : size}}>Signup</div>
        </div>
    )
});

export const DividerTrendView = React.memo((props) => {
    const size = '44px'
    return(
        <div className='dividerView' style={{width : '100%', fontSize : '16px'}}>
            <div className='dividerItemView dividerLeftView' style={{height : size, color : '#FFF',  border : 'none', background : '#08BF89'}}>Buy</div>
            <div style={{width : '2px'}}></div>
            <div className='dividerItemView dividerRightView' style={{height : size, color : '#FFF',  border : 'none', background : '#F0495B'}}>Sell</div>
        </div>
    )
});

export const DividerOptionView = React.memo((props) => {
    const leftText = props.leftText || 'Left';
    const rightText = props.rightText || 'Right';
    const size = props.height || '44px'
    const left = props.left
    const color = '#0E1C39';
    const borderRadius = props.borderRadius || '10px'
    const topBorder = props.topBorder === undefined
    const onClick = (val) => {
        props.onChange(val)
    }
    return(
        <div className='dividerView' style={{width : '100%'}}>
            <div onClick={()=> {onClick(true)}} className='dividerItemView dividerLeftView' style={{
                    height : size,
                    backgroundColor: left ? color : 'transparent',
                    borderRadius : borderRadius,
                    borderTopRightRadius : '0',
                    borderBottomRightRadius : '0',
                    borderTopLeftRadius : topBorder ? borderRadius : '0',
                    borderColor : color
                }}>
                {
                    left ? <span>{leftText}</span> : <>{leftText}</>
                }
            </div>
            <div onClick={()=> {onClick(false)}} className='dividerItemView dividerRightView' style={{
                    height : size,
                    backgroundColor: left ? 'transparent' : color,
                    borderRadius : borderRadius,
                    borderTopLeftRadius : '0',
                    borderBottomLeftRadius : '0',
                    borderTopRightRadius : topBorder ? borderRadius : '0',
                    borderColor : color
                }}>
                {
                    left ? <>{rightText}</> : <span>{rightText}</span>
                }
            </div>
        </div>
    )
});

export const DividerTradeView = React.memo((props) => {
    const leftText = props.leftText || 'Left';
    const rightText = props.rightText || 'Right';
    const size = props.height || '44px'
    const left = props.left
    const color = props.color || '#08BF89'
    const borderRadius = props.borderRadius || '10px'
    const topBorder = props.topBorder === undefined
    const onClick = (val) => {
        props.onChange(val)
    }
    return(
        <div className='dividerView' style={{width : '100%'}}>
            <div onClick={()=> {onClick(true)}} className='dividerItemView dividerLeftView' style={{
                    height : size,
                    backgroundColor: left ? color : 'transparent',
                    borderRadius : borderRadius,
                    borderTopRightRadius : '0',
                    borderBottomRightRadius : '0',
                    borderTopLeftRadius : topBorder ? borderRadius : '0',
                    borderColor : color,
                    color : left ? '#FFF' : color
                }}>
                {leftText}
            </div>
            <div onClick={()=> {onClick(false)}} className='dividerItemView dividerRightView' style={{
                    height : size,
                    backgroundColor: left ? 'transparent' : color,
                    borderRadius : borderRadius,
                    borderTopLeftRadius : '0',
                    borderBottomLeftRadius : '0',
                    borderTopRightRadius : topBorder ? borderRadius : '0',
                    borderColor : color,
                    color : !left ? '#FFF' : color
                }}>
                {rightText}
            </div>
        </div>
    )
});

export const CoinHeaderView = React.memo(({item = {}}) => {
    let rate = ConvertToRate(item)
    if(rate === 'NaN') {
        rate = '0.00'
    }
    const rateCss = rate < 0 ? 'change down' : 'change up'
    return (
        <div className='coinHeaderView'>
            <div className='left'>
                <div className='price'>
                   <div className='value'>{item.close}</div>
                   <div className={rateCss}>{rate}%</div>
                </div>
                <div className='about'>≈ {item.close}$</div>
            </div>
            <div className='right'>
                <div style={{padding : '1px 0'}}>Today Hight: {item.high}</div>
                <div style={{padding : '1px 0'}}>Today Low: {item.low}</div>
            </div>
        </div>
    )
});

export const LoadView = React.memo((props) => {
    return (
        <div className='loadView' {...props}>
           <SpinLoading color='primary' style={{'--size' : '40px'}}/>
           <CoinImgView src={props.src || ''} style={{'--size' : '30px', '--border-radius' : '100px', position : 'absolute', left : '5px', top : '5px'}}/>
        </div>
    );
});

const DepthItem = React.memo((props) => {
    const bgWidth = props.bgWidth || '0'
    const color = props.color || 'red'
    return <div style={{flex : props.flex, display : 'flex', alignItems : 'center', fontSize : '11px', position : 'relative'}}>
        <div style={{position : 'absolute', opacity : '0.06', borderRadius : '2px', background : color, left: (100 - bgWidth) + '%', width : bgWidth + '%', height : '100%', zIndex:'0'}}></div>
        <div style={{flex : '1', color : color, zIndex : '1'}}><EllipsisView content={props.price}/></div>
        <div style={{width : '4px', zIndex : '1'}}></div>
        <div style={{flex : '1', textAlign : 'right', color : 'gray', zIndex : '1'}}><EllipsisView content={props.amount}/></div>
    </div>
});

export const DepthView = React.memo((props) => {

    const {asks = {}, bids = {}, marketPrice = '0.00'} = props.data || {}
    const asksData = asks.data || []
    const asksMax = asks.max || DecimalZero()
    const bidsData = bids.data || []
    const bidsMax = bids.max || DecimalZero()
    const bgValue = (amount, max) => {
        let value = BigDecimalZero(amount).div(max).mul(BigDecimalZero('100')).toFixed(2)
        if(value > 100) {
            value = '100'
        }
        return value
    }
    return (
        <div style={{display : 'flex', height : '100%', flexDirection : 'column'}}>
            <DepthItem flex='0' price='Price' amount ='Amount' color='gray'/>
            {
                asksData.map((item, index) => (
                    <DepthItem 
                        key={index} 
                        flex='1' 
                        price={item.price} 
                        amount={item.amount}
                        bgWidth={`${bgValue(item.amount, asksMax)}`}
                        color='#D92727'
                    />
                 ))
            }
            <div style={{flex : '0'}}>
                <div style={{fontSize : '18px', fontWeight : 'bold', color : '#D92727'}}>{marketPrice}</div>
                <div style={{fontSize : '13px', color : 'gray'}}>{marketPrice}$</div>
            </div>
            {
                 bidsData.map((item, index) => (
                    <DepthItem 
                        key={index} 
                        flex='1' 
                        price={item.price} 
                        amount={item.amount}
                        bgWidth={`${bgValue(item.amount, bidsMax)}`}
                        color='#08BF89'
                    />
                 ))
            }
        </div>
    );
});

export const TradeFuturesBodyView = React.memo((props) => {
    return (
        <div style={{display : 'flex'}}>
            <div style={{flex : '1'}}>{props.children}</div>
            <div style={{width : '14px'}}></div>
            <div style={{flex : '0.5'}}><DepthView data={props.depthData}/></div>
        </div>
    );
});

export const TradeCoinsBodyView = React.memo((props) => {
    return (
        <div style={{display : 'flex'}}>
            <div style={{flex : '0.5'}}><DepthView data={props.depthData}/></div>
            <div style={{width : '14px'}}></div>
            <div style={{flex : '1'}}>{props.children}</div>
        </div>
    );
});

export const SelectView = React.memo((props)=> {
    return (
        <div className='selectView' {...props}>
            <div className='left'>{props.children}</div>
            <div className='right'><DownFill/></div>
        </div>
    );
});

export const TradeButtonView = React.memo((props)=> {
    return (
        <div className='tradeButtonView' {...props}>
            {props.children}
        </div>
    );
});


export const CoinImgView = React.memo((props)=> {
    return (
        <Avatar fallback = {<div style={{
            background : '#eee',
            width: '100%',
            height : '100%'
        }}></div>} {...props}/>
    );
});

export const MarketAvatarView = React.memo(({src})=> {
    if (src === undefined) {
        return (<></>)
    }
    return (
        <CoinImgView src={FullURL(src)} style={{'--size' : '32px', '--border-radius' : '100px', marginRight : '10px'}}/>
    );
});

export const TradeHeaderView =  React.memo((props)=> {
    const data = props.data || {}
    let rate = ConvertToRate(data)
    if(rate === 'NaN') {
        rate = '0.00'
    }
    const followed = props.followed === true
    const borderColor = rate>=0 ? '#E6F8F3' : '#FEEEEF'
    const color = rate>=0 ? '#08BF89' : '#D92727'
   
    return (
        <div style={{display : 'flex', alignItems : 'center', fontSize : '14px', fontWeight: 'bold'}}>
            <div onClick={props.onClick} style={{display : 'flex', alignItems: 'center', border : '1px '+borderColor+' solid', borderRadius : '6px', overflow : 'hidden'}}>
                <div style={{display : 'flex', margin : '0 10px'}}>
                    <div><TradeMoreIcon/></div>
                    <div>{data.symbol}</div>
                </div>
                <div style={{background : borderColor, padding : '7px 12px', color : color}}>{rate}%</div>
            </div>
            <div style={{flex: '1', padding : '0 5px'}}></div>
            <div style={{display : 'flex', alignItems: 'center'}}>
                <div onClick={props.goTrend} ><TrendIcon /></div>
                <div style={{width : '6px'}}></div>
                <div onClick={()=>{DoFavorite(data.symbol)}}>
                    {followed ? <FavoritesOKIcon/> : <FavoritesIcon/>}
                </div>
            </div>
        </div>
    );
});

export const PopupSelectView =  React.memo((props)=> {
    const visible =  props.visible
    const height = props.height || '70vh'
    const title = props.title || 'Please select'
    return (
        <Popup
                visible={visible}
                onMaskClick = {props.close}
                bodyStyle={{
                    borderTopLeftRadius: '16px',
                    borderTopRightRadius: '16px',
                    fontSize : '17px',
                    color : '#000'
                }}
            >
                <div style={{textAlign : 'center', fontWeight : 'bold', padding : '15px 0', borderBottom : '1px #eee solid'}}>{title}</div>
                <div style={{height : height, padding : '6px 15px', overflowY : 'scroll'}}>
                    <ListView>
                        {props.children}
                    </ListView>
                </div>
        </Popup>
    )
})